import React from "react";
import styles from "./Welcome.module.scss";

export default function Welcome() {
  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <div className={styles.contentWrapper}>
          <div className={styles.headerWrapper}>
            <div className={styles.welcomeText}>Welcome to Troak</div>
            <h1 className={styles.mainTitle}>
              discover the world's best quality visual stories
            </h1>
          </div>
          <div className={styles.imageSection}>
            <div className={styles.badge}>
              <div className={styles.badgeText}>Popular</div>
            </div>
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/c1a0f348f8c61cb65c7fc3b02b188be6b156a3d12e3977dc8a5c085b45b45b4e?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05"
              className={styles.storyImage}
              alt="Visual story preview"
            />
            <div className={styles.descriptionWrapper}>
              <p className={styles.description}>
                <span className={styles.descriptionBold}>
                  Dive into Gripping Stories
                </span>
                <br />
                Immerse yourself in Troak, where every choice you make shapes
                the story. Explore rich, immersive narratives filled with drama,
                intrigue, and unforgettable characters.
              </p>
              <button
                className={styles.playButton}
                tabIndex="0"
                aria-label="Start playing"
              >
                <div className={styles.playButtonContent}>
                  <span className={styles.playText}>Play</span>
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/ad90077ba36dd18e3607bbbeba71f89faf9ef145724526791e8241b7e8d2dffd?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05"
                    className={styles.playIcon}
                    alt=""
                  />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
